import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import history from './history';

export function withRouter(Component) {
    function WithRouter(props) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();

        const historyCompat = {
            push: navigate,
            replace: (to) => navigate(to, { replace: true }),
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            location,

            listen: (callback) => history.listen(({ action, location }) => callback(location, action)),

            block: (callback) => {
                let unblock;
                const arm = () => {
                    unblock = history.block(({ action, location, retry }) => {
                        const result = callback(location, action);
                        if (!result || window.confirm(result)) {
                            unblock(); // stop blocking
                            const stop = history.listen(() => {
                                // re-arm AFTER nav applies
                                stop();
                                arm();
                            });
                            retry();
                        }
                        // else: stay (history v5 already reverted)
                    });
                };
                arm();
                return () => unblock();
            }
        };

        const match = {
            params,
            path: location.pathname,
            url: location.pathname
        };

        return <Component {...props} history={historyCompat} location={location} match={match} />;
    }

    WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
    return WithRouter;
}
